import React from "react";

export default function LightningIcon({ className = "w-16 h-16" }) {
    return (
        <svg
            className={className}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M36 8L18 36H32L28 56L46 28H32L36 8Z"
                fill="#7FFF00"
                stroke="#0A1E3E"
                strokeWidth="2"
                strokeLinejoin="round"
            />
            <path
                d="M40 12L46 20M22 44L16 52M48 36L54 40M10 24L16 28"
                stroke="#7FFF00"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
}
